var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module2, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", !isNodeMode && module2 && module2.__esModule ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  ColorInlineLoader: () => ColorInlineLoader,
  ColorSpinner: () => ColorSpinner,
  ContentLoader: () => ContentLoader,
  DarkFullScreenLoader: () => DarkFullScreenLoader,
  DarkInlineLoader: () => DarkInlineLoader,
  DarkSpinner: () => DarkSpinner,
  LightFullScreenLoader: () => LightFullScreenLoader,
  LightInlineLoader: () => LightInlineLoader,
  LightSpinner: () => LightSpinner,
  Skeleton: () => Skeleton,
  SkeletonCircle: () => SkeletonCircle,
  SkeletonText: () => SkeletonText,
  Spinner: () => Spinner
});

// src/ColorInlineLoader.tsx
var import_react4 = require("@chakra-ui/react");
var import_spor_loader = require("@vygruppen/spor-loader");
var import_react5 = __toESM(require("react"));

// src/ClientOnly.tsx
var import_react2 = __toESM(require("react"));

// src/useHydrated.tsx
var import_react = require("react");
var hydrating = true;
function useHydrated() {
  let [hydrated, setHydrated] = (0, import_react.useState)(() => !hydrating);
  (0, import_react.useEffect)(function hydrate() {
    hydrating = false;
    setHydrated(true);
  }, []);
  return hydrated;
}

// src/ClientOnly.tsx
var ClientOnly = ({ children, fallback = null }) => {
  const isHydrated = useHydrated();
  return /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null, isHydrated ? children() : fallback);
};

// src/Lottie.tsx
var import_lottie_react = __toESM(require("lottie-react"));
var import_react3 = __toESM(require("react"));
function Lottie({ animationData }) {
  return /* @__PURE__ */ import_react3.default.createElement(import_lottie_react.default, {
    animationData,
    loop: true
  });
}

// src/ColorInlineLoader.tsx
var ColorInlineLoader = (_a) => {
  var _b = _a, {
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react5.default.createElement(import_react4.Center, __spreadValues({}, props), /* @__PURE__ */ import_react5.default.createElement(import_react4.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react5.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react5.default.createElement(Lottie, {
    animationData: import_spor_loader.inlineLoaderColorData
  }))));
};

// src/ColorSpinner.tsx
var import_react6 = require("@chakra-ui/react");
var import_spor_loader2 = require("@vygruppen/spor-loader");
var import_react7 = __toESM(require("react"));
var ColorSpinner = (_a) => {
  var _b = _a, {
    children,
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "children",
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react7.default.createElement(import_react6.Center, __spreadValues({
    flexDirection: "column"
  }, props), /* @__PURE__ */ import_react7.default.createElement(import_react6.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react7.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react7.default.createElement(Lottie, {
    animationData: import_spor_loader2.spinnerColorData
  }))), children && /* @__PURE__ */ import_react7.default.createElement(import_react6.Box, {
    mt: 3,
    fontWeight: "bold"
  }, children));
};
var Spinner = ColorSpinner;

// src/ContentLoader.tsx
var import_react8 = require("@chakra-ui/react");
var import_spor_loader3 = require("@vygruppen/spor-loader");
var import_react9 = __toESM(require("react"));
var ContentLoader = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ import_react9.default.createElement(import_react8.Box, __spreadValues({}, props), /* @__PURE__ */ import_react9.default.createElement(import_react8.Box, {
    maxWidth: "140px",
    mx: "auto"
  }, /* @__PURE__ */ import_react9.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react9.default.createElement(Lottie, {
    animationData: import_spor_loader3.contentLoaderData
  }))), children && /* @__PURE__ */ import_react9.default.createElement(import_react8.Box, {
    textAlign: "center",
    fontWeight: "bold"
  }, children));
};

// src/DarkFullScreenLoader.tsx
var import_react10 = require("@chakra-ui/react");
var import_spor_loader4 = require("@vygruppen/spor-loader");
var import_react11 = __toESM(require("react"));
var DarkFullScreenLoader = (_a) => {
  var _b = _a, {
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react11.default.createElement(import_react10.Center, __spreadValues({
    height: "100%",
    background: "alias.darkTeal"
  }, props), /* @__PURE__ */ import_react11.default.createElement(import_react10.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react11.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react11.default.createElement(Lottie, {
    animationData: import_spor_loader4.fullScreenLoaderWhiteData
  }))));
};

// src/DarkInlineLoader.tsx
var import_react12 = require("@chakra-ui/react");
var import_spor_loader5 = require("@vygruppen/spor-loader");
var import_react13 = __toESM(require("react"));
var DarkInlineLoader = (_a) => {
  var _b = _a, {
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react13.default.createElement(import_react12.Center, __spreadValues({}, props), /* @__PURE__ */ import_react13.default.createElement(import_react12.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react13.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react13.default.createElement(Lottie, {
    animationData: import_spor_loader5.inlineLoaderDarkData
  }))));
};

// src/DarkSpinner.tsx
var import_react14 = require("@chakra-ui/react");
var import_spor_loader6 = require("@vygruppen/spor-loader");
var import_react15 = __toESM(require("react"));
var DarkSpinner = (_a) => {
  var _b = _a, {
    children,
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "children",
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react15.default.createElement(import_react14.Center, __spreadValues({
    flexDirection: "column"
  }, props), /* @__PURE__ */ import_react15.default.createElement(import_react14.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react15.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react15.default.createElement(Lottie, {
    animationData: import_spor_loader6.spinnerDarkData
  }))), children && /* @__PURE__ */ import_react15.default.createElement(import_react14.Box, {
    mt: 3,
    fontWeight: "bold"
  }, children));
};

// src/LightFullScreenLoader.tsx
var import_react16 = require("@chakra-ui/react");
var import_spor_loader7 = require("@vygruppen/spor-loader");
var import_react17 = __toESM(require("react"));
var LightFullScreenLoader = (_a) => {
  var _b = _a, {
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react17.default.createElement(import_react16.Center, __spreadValues({
    height: "100%",
    background: "alias.white"
  }, props), /* @__PURE__ */ import_react17.default.createElement(import_react16.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react17.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react17.default.createElement(Lottie, {
    animationData: import_spor_loader7.fullScreenLoaderBlackData
  }))));
};

// src/LightInlineLoader.tsx
var import_react18 = require("@chakra-ui/react");
var import_spor_loader8 = require("@vygruppen/spor-loader");
var import_react19 = __toESM(require("react"));
var LightInlineLoader = (_a) => {
  var _b = _a, {
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react19.default.createElement(import_react18.Center, __spreadValues({}, props), /* @__PURE__ */ import_react19.default.createElement(import_react18.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react19.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react19.default.createElement(Lottie, {
    animationData: import_spor_loader8.inlineLoaderLightData
  }))));
};

// src/LightSpinner.tsx
var import_react20 = require("@chakra-ui/react");
var import_spor_loader9 = require("@vygruppen/spor-loader");
var import_react21 = __toESM(require("react"));
var LightSpinner = (_a) => {
  var _b = _a, {
    children,
    width,
    maxWidth
  } = _b, props = __objRest(_b, [
    "children",
    "width",
    "maxWidth"
  ]);
  return /* @__PURE__ */ import_react21.default.createElement(import_react20.Center, __spreadValues({
    flexDirection: "column"
  }, props), /* @__PURE__ */ import_react21.default.createElement(import_react20.Box, {
    width,
    maxWidth
  }, /* @__PURE__ */ import_react21.default.createElement(ClientOnly, null, () => /* @__PURE__ */ import_react21.default.createElement(Lottie, {
    animationData: import_spor_loader9.spinnerLightData
  }))), children && /* @__PURE__ */ import_react21.default.createElement(import_react20.Box, {
    mt: 3,
    fontWeight: "bold"
  }, children));
};

// src/Skeleton.tsx
var import_react22 = require("@chakra-ui/react");
var import_react23 = __toESM(require("react"));
var Skeleton = (props) => /* @__PURE__ */ import_react23.default.createElement(import_react22.Skeleton, __spreadValues({}, props));

// src/SkeletonCircle.tsx
var import_react24 = require("@chakra-ui/react");
var import_react25 = __toESM(require("react"));
var SkeletonCircle = (props) => /* @__PURE__ */ import_react25.default.createElement(import_react24.SkeletonCircle, __spreadValues({
  boxSize: 6,
  borderRadius: "50%"
}, props));

// src/SkeletonText.tsx
var import_react26 = require("@chakra-ui/react");
var import_react27 = __toESM(require("react"));
var SkeletonText = (props) => /* @__PURE__ */ import_react27.default.createElement(import_react26.SkeletonText, __spreadValues({
  boxSize: 6
}, props));
module.exports = __toCommonJS(src_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ColorInlineLoader,
  ColorSpinner,
  ContentLoader,
  DarkFullScreenLoader,
  DarkInlineLoader,
  DarkSpinner,
  LightFullScreenLoader,
  LightInlineLoader,
  LightSpinner,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Spinner
});
